var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticClass: "box-card",
      attrs: {
        "body-style": { padding: "20px" },
        shadow: "never",
        bordered: false,
      },
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "el-col",
            _vm._b({}, "el-col", _vm.grid, false),
            [
              _c(
                "el-form-item",
                { attrs: { label: "任务名称：", required: "" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: {
                      maxlength: "100",
                      "show-word-limit": "",
                      placeholder: "请输入任务名称",
                      disabled: _vm.disabled,
                    },
                    model: {
                      value: _vm.value.taskName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.value,
                          "taskName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "value.taskName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "参与条件：", required: "" } },
                [
                  _vm.value.taskMode === 1
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "from-ipt-width",
                              attrs: {
                                disabled: _vm.disabled || _vm.isAuto,
                                size: "small",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.value.taskType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.value, "taskType", $$v)
                                },
                                expression: "value.taskType",
                              },
                            },
                            _vm._l(_vm.taskTypeOptions, function (item, idx) {
                              return _c("el-option", {
                                key: idx,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.value.taskMode === 3
                    ? _c(
                        "div",
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: { value: "双倍视频奖励", disabled: "" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _vm.value.taskType === 1
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "展示广告：", required: "" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "from-ipt-width",
                            attrs: {
                              disabled: _vm.disabled,
                              size: "small",
                              placeholder: "请选择",
                            },
                            model: {
                              value: _vm.value.advId,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "advId", $$v)
                              },
                              expression: "value.advId",
                            },
                          },
                          _vm._l(_vm.adList, function (item, idx) {
                            return _c("el-option", {
                              key: idx,
                              attrs: {
                                label: item.adName + "(" + item.id + ")",
                                value: item.id,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm.value.taskType === 4
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "跳转类型：", required: "" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: _vm.disabled },
                            model: {
                              value: _vm.value.jumpType,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "jumpType", $$v)
                              },
                              expression: "value.jumpType",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("直接跳转"),
                            ]),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v("半屏小程序"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "小程序appid：", required: "" } },
                      [
                        _c("el-input", {
                          staticClass: "from-ipt-width",
                          attrs: { disabled: _vm.disabled },
                          model: {
                            value: _vm.value.appId,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "appId", $$v)
                            },
                            expression: "value.appId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "页面路径：", required: "" } },
                      [
                        _c("el-input", {
                          staticClass: "from-ipt-width",
                          attrs: { disabled: _vm.disabled },
                          model: {
                            value: _vm.value.jumpUrl,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "jumpUrl", $$v)
                            },
                            expression: "value.jumpUrl",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "每日任务上限：", required: "" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 1,
                      step: 1,
                      disabled: _vm.disabled,
                      "controls-position": "right",
                      "step-strictly": "",
                    },
                    model: {
                      value: _vm.value.dailyLimit,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "dailyLimit", $$v)
                      },
                      expression: "value.dailyLimit",
                    },
                  }),
                  _vm._v("次 "),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v("控制活动每日参与次数上限"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "赠送抽奖券：", required: "" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 1,
                      step: 1,
                      disabled: _vm.disabled,
                      "controls-position": "right",
                      "step-strictly": "",
                    },
                    model: {
                      value: _vm.value.rewardTicket,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "rewardTicket", $$v)
                      },
                      expression: "value.rewardTicket",
                    },
                  }),
                  _vm._v("张 "),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v("用户完成任务后所获得抽奖券总数"),
                  ]),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }